function customerAddressForm() {
  var newAddressForm = document.getElementById('AddressNewForm');
  var newAddressFormButton = document.getElementById('AddressNewButton');

  // Toggle new/edit address forms
  document.querySelectorAll('.address-new-toggle').forEach(function(button) {
    button.addEventListener('click', function() {
      var isExpanded =
        newAddressFormButton.getAttribute('aria-expanded') === 'true';

      newAddressForm.classList.toggle('hide');
      newAddressFormButton.setAttribute('aria-expanded', !isExpanded);
      newAddressFormButton.focus();
    });
  });

  document.querySelectorAll('.address-edit-toggle').forEach(function(button) {
    button.addEventListener('click', function(evt) {
      var formId = evt.target.dataset.formId;
      var editButton = document.getElementById('EditFormButton_' + formId);
      var editAddress = document.getElementById('EditAddress_' + formId);
      var isExpanded = editButton.getAttribute('aria-expanded') === 'true';

      editAddress.classList.toggle('hide');
      editButton.setAttribute('aria-expanded', !isExpanded);
      editButton.focus();
    });
  });

  document.querySelectorAll('.address-delete').forEach(function(button) {
    button.addEventListener('click', function(evt) {
      var target = evt.target.dataset.target;
      var confirmMessage = evt.target.dataset.confirmMessage;

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink(target, {
          parameters: { _method: 'delete' }
        });
      }
    });
  });
}
customerAddressForm()